import * as React from 'react';

/** Phones: single-column layouts, card lists instead of tables. */
export const MOBILE_QUERY = '(max-width: 767px)';
/** Tablets and small laptops: the sidebar collapses into a drawer. */
export const COMPACT_QUERY = '(max-width: 1023px)';

export function useMediaQuery(query: string): boolean {
    const getMatch = React.useCallback(() => window.matchMedia?.(query).matches ?? false, [query]);
    const [matches, setMatches] = React.useState<boolean>(getMatch);

    React.useEffect(() => {
        const list = window.matchMedia?.(query);
        if (!list) return;
        const onChange = (event: MediaQueryListEvent): void => setMatches(event.matches);
        setMatches(list.matches);
        list.addEventListener('change', onChange);
        return () => list.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}

export const useIsMobile = (): boolean => useMediaQuery(MOBILE_QUERY);
export const useIsCompact = (): boolean => useMediaQuery(COMPACT_QUERY);
